import { render, staticRenderFns } from "./UnorderedList.vue?vue&type=template&id=f310797c&"
import script from "./UnorderedList.vue?vue&type=script&lang=ts&"
export * from "./UnorderedList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports